/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Wed Dec 08 2021 10:27:21 GMT+0100 (GMT+01:00)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.COLLECTION;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface Collection {
  colassigndate: string;
  colcomment: string;
  colenddate: string;
  colid: number;
  collabel: string;
  colreference: string;
  colstartdate: string;
  colstatus: string;
  coluserid: number;
  created_at: Timestamp;
  created_by: number;
  jobid: number;
  last_action: string;
  proctaskid: number;
  tpidclient: number;
  updated_at: Timestamp;
  updated_by: number;
}

export interface CollectionRequest {
  ciid: number;
  colassigndate: string;
  colcomment: string;
  colenddate: string;
  colid: number;
  collabel: string;
  colreference: string;
  colstartdate: string;
  colstatus: string;
  coluserid: number;
  created_at: Timestamp;
  created_by: number;
  jobid: number;
  last_action: string;
  proctaskid: number;
  rejectionReasion: string;
  tpidclient: number;
  updated_at: Timestamp;
  updated_by: number;
}

export interface CollectionResponse {
  colassigndate: string;
  colcomment: string;
  colenddate: string;
  colid: number;
  currcode: string;
  collabel: string;
  collevel: string;
  collevellabel: string;
  colmanagerName: string;
  colreference: string;
  colstartdate: string;
  colstatus: string;
  colstatusLabel: string;
  colstatusdate: string;
  colstate: string;
  colstatelabel: string;
  totalinvoicedamount: number;
  managertype: string;
  managerroleprofile: string;
  lastinvoicedate: string;
  firstinvoicedate: string;
  managertypelabel: string;
  managerroleprofilelabel: string;

  colunpaidList: Array<ColunpaidResponse>;
  coluserid: number;
  created_at: Timestamp;
  created_by: number;
  jobid: number;
  last_action: number;
  paidamountafterreminder: number;
  proctaskid: number;
  totaloutstanding: number;
  totalunpaid: number;
  tpadrid: number;
  tpemail: string;
  tpidclient: number;
  tpname: string;
  tpreference: string;
  tpsalestatus: string;
  tptel1: string;
  unpaidnbreofdays: number;
  updated_at: Timestamp;
  updated_by: number;
  unpaidmaxnbdays: number;
  unpaidmaxamount: number;
  unpaidmaxamountdate: string;
  unpaidmaxnbdaysdate: string;
}
export interface ColmanagerResponse {
  associd: number;
  colid: number;
  collabel: string;
  colreference: string;
  coluserid: number;
  enddate: string;
  startdate: string;
  username: string;
}

export interface Colpromise {
  ciid: number;
  colid: number;
  promcomment: string;
  proctaskid: number;
  promamount: number;
  promcreationdate: string;
  promdate: string;
  promid: number;
  promstatus: string;
  promstatusdate: string;
}

export interface ColpromiseResponse {
  ciid: number;
  colid: number;
  collabel: string;
  tpname: string;
  colpromstatusLabel: string;
  colreference: string;
  promcomment: string;
  proctaskid: number;
  promamount: number;
  promcreationdate: string;
  promdate: string;
  promid: number;
  promstatus: string;
  promstatusdate: string;
  promtype: string;
  promtypelabel: string;
  userid: number;
  username: string;
  cireference: string;
}

export interface Colunpaid {
  cidocdate: string;
  cigrosstotal: number;
  ciid: number;
  cilateinterestcalculatedamount: number;
  cilateinterestcalculateddate: string;
  cilateinterestinvoicedamount: number;
  cipaymentdate: string;
  cipaymentmode: string;
  cirejecteddate: string;
  cirejectedfeesinvoicedamount: number;
  cirejectfeesamount: number;
  cirejectreason: string;
  cistatus: string;
  ciunpaidamount: number;
  civaluedate: string;
  colid: number;
  cunpid: number;
}

export interface ColunpaidResponse {
  cidocdate: string;
  cigrosstotal: number;
  ciid: number;
  cilateinterestcalculatedamount: number;
  cilateinterestcalculateddate: string;
  cilateinterestinvoicedamount: number;
  cipaymentdate: string;
  cipaymentmode: string;
  cireference: string;
  cirejecteddate: string;
  cirejectedfeesinvoicedamount: number;
  cirejectfeesamount: number;
  cirejectreason: string;
  cistatus: string;
  ciunpaidamount: number;
  civaluedate: string;
  colid: number;
  collabel: string;
  colreference: string;
  cunpid: number;
}

export interface Timestamp {
  date: number;
  day: number;
  hours: number;
  minutes: number;
  month: number;
  nanos: number;
  seconds: number;
  time: number;
  timezoneOffset: number;
  year: number;
}
export interface ColStatusResponse {
  colid: number;
  collevel: string;
  colstatus: string;
  colstatusdate: string;
  oldcollevel: string;
  oldcolstatus: string;
  oldcolstatusdate: string;
  taskid: number;
  updated_at: string;
  userid: number;
}
export interface GetColStatusHistoryParams {
  colid: number;
}

/**
 * @tags Collection Controller
 * @summary GetColStatusHistory
 */
export function GetColStatusHistory(params: GetColStatusHistoryParams) {
  return request.get<AbstractResponse<object, ColStatusResponse>>(
    `${URL}/api/colstatushistory/${params.colid}`
  );
}
export interface CreateCollectionParams {
  request: CollectionRequest;
  token: string;
}

/**
 * @tags Collection Controller
 * @summary createCollection
 */
export function createCollection(params: CreateCollectionParams) {
  return request.post<AbstractResponse<Collection, object>>(
    `${URL}/api/collection`,
    params.request
  );
}

/**
 * @tags Collection Controller
 * @summary getColpromise
 */
export function getColpromise() {
  return request.get<AbstractResponse<object, ColpromiseResponse>>(
    `${URL}/api/collection/colpromise`
  );
}

export interface UpdateColpromiseParams {
  promid: number;
  request: Colpromise;
}

/**
 * @tags Collection Controller
 * @summary UpdateColpromise
 */
export function UpdateColpromise(params: UpdateColpromiseParams) {
  return request.put<AbstractResponse<Colpromise, object>>(
    `${URL}/api/collection/colpromise/${params.promid}`,
    params.request
  );
}

export interface UpdateColunpaidParams {
  cunpid: number;
  request: Colunpaid;
}

/**
 * @tags Collection Controller
 * @summary UpdateColunpaid
 */
export function UpdateColunpaid(params: UpdateColunpaidParams) {
  return request.put<AbstractResponse<Colunpaid, object>>(
    `${URL}/api/collection/colunpaid/${params.cunpid}`,
    params.request
  );
}

export interface AssignManagerParams {
  colid: number;
  iAssignDate: string;
  iuserid: number;
}

/**
 * @tags Collection Controller
 * @summary AssignManager
 */
export function AssignManager(params: AssignManagerParams) {
  return request.post<AbstractResponse<Collection, object>>(
    `${URL}/api/collection/${params.colid}` +
      prepareQueryParams({
        iAssignDate: params.iAssignDate,
        iuserid: params.iuserid,
      } as any)
  );
}

export interface UpdateCollectionParams {
  colid: number;
  request: Collection;
}

/**
 * @tags Collection Controller
 * @summary UpdateCollection
 */
export function UpdateCollection(params: UpdateCollectionParams) {
  return request.put<AbstractResponse<Collection, object>>(
    `${URL}/api/collection/${params.colid}`,
    params.request
  );
}

export interface GetColmanagerByColidParams {
  colid: number;
}

/**
 * @tags Collection Controller
 * @summary getColmanagerByColid
 */
export function getColmanagerByColid(params: GetColmanagerByColidParams) {
  return request.get<AbstractResponse<object, ColmanagerResponse>>(
    `${URL}/api/collection/${params.colid}/colmanager`
  );
}

export interface GetColpromiseByColidParams {
  colid: number;
  promtype: string;
}

/**
 * @tags Collection Controller
 * @summary getColpromiseByColid
 */
export function getColpromiseByColid(params: GetColpromiseByColidParams) {
  return request.get<AbstractResponse<object, ColpromiseResponse>>(
    `${URL}/api/collection/${params.colid}/colpromise` +
      prepareQueryParams({ promtype: params.promtype } as any)
  );
}

export interface AddColpromiseParams {
  colid: number;
  request: Colpromise;
}

/**
 * @tags Collection Controller
 * @summary addColpromise
 */
export function addColpromise(params: AddColpromiseParams) {
  return request.post<AbstractResponse<Colpromise, object>>(
    `${URL}/api/collection/${params.colid}/colpromise`,
    params.request
  );
}

export interface GetColunpaidByColidParams {
  colid: number;
}

/**
 * @tags Collection Controller
 * @summary getColunpaidByColid
 */
export function getColunpaidByColid(params: GetColunpaidByColidParams) {
  return request.get<AbstractResponse<object, ColunpaidResponse>>(
    `${URL}/api/collection/${params.colid}/colunpaid`
  );
}

export interface AddcolunpaidParams {
  ciid: number;
  colid: number;
  token: string;
}

/**
 * @tags Collection Controller
 * @summary Addcolunpaid
 */
export function Addcolunpaid(params: AddcolunpaidParams) {
  return request.post<AbstractResponse<Colunpaid, object>>(
    `${URL}/api/collection/${params.colid}/colunpaid/${params.ciid}`
  );
}

export interface UpdateCollectionStatusParams {
  colid: number;
  colstatus: string;
}

/**
 * @tags Collection Controller
 * @summary UpdateCollectionStatus
 */
export function UpdateCollectionStatus(params: UpdateCollectionStatusParams) {
  return request.put<AbstractResponse<Collection, object>>(
    `${URL}/api/collection/${params.colid}/${params.colstatus}`
  );
}

export interface UpdateStatusColpromiseParams {
  promid: number;
  promstatus: string;
}

/**
 * @tags Collection Controller
 * @summary UpdateStatusColpromise
 */
export function UpdateStatusColpromise(params: UpdateStatusColpromiseParams) {
  return request.put<AbstractResponse<Colpromise, object>>(
    `${URL}/api/colpromise/${params.promid}/${params.promstatus}`
  );
}

/**
 * @tags Collection Controller
 * @summary getBuildingInfo
 */
export function getBuildingInfo() {
  return request.get<string>(`${URL}/api/version`);
}

export interface JobExecutionResponse {
  code: string;
  description: string;
  errorfile: string;
  jobid: number;
  logfile: string;
  message: string;
  outputfile: string;
  servicename: string;
}

export interface RunCollectionParams {
  duedate: string;
  mgid: number;
  tpidend: number;
  tpidstart: number;
}

/**
 * @tags Collection Controller
 * @summary runCollection
 */
export function runCollection(params: RunCollectionParams) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/run/collection` +
      prepareQueryParams({
        duedate: params.duedate,
        mgid: params.mgid,
        tpidend: params.tpidend,
        tpidstart: params.tpidstart,
      } as any)
  );
}

export interface GetCollectionByColidParams {
  colid: number;
}

/**
 * @tags Collection Controller
 * @summary getCollectionByColid
 */
export function getCollectionByColid(params: GetCollectionByColidParams) {
  return request.get<AbstractResponse<CollectionResponse, object>>(
    `${URL}/api/collection/${params.colid}`
  );
}

export interface FindCollectionByanyRefParams {
  collevel?: string;
  colstate?: string;
  colreference: string;
  colstatus: string;
  coluserid: number;
  tpidclient: number;
}

/**
 * @tags Collection Controller
 * @summary findCollectionByanyRef
 */
export function findCollectionByanyRef(params: FindCollectionByanyRefParams) {
  return request.get<AbstractResponse<object, CollectionResponse>>(
    `${URL}/api/collectionByCriteria` +
      prepareQueryParams({
        collevel: params.collevel,
        colstate: params.colstate,
        colreference: params.colreference,
        colstatus: params.colstatus,
        coluserid: params.coluserid,
        tpidclient: params.tpidclient,
      } as any)
  );
}

export interface BatchJobExecution {
  create_time: string;
  end_time: string;
  errorfile: string;
  exit_code: string;
  exit_message: string;
  job_configuration_location: string;
  job_execution_id: number;
  job_instance_id: number;
  last_updated: string;
  logfile: string;
  logfolder: string;
  module: string;
  outputfile: string;
  outputfolder: string;
  serviceexecparam: string;
  servicename: string;
  start_time: string;
  status: string;
  userid: number;
  version: number;
}

export interface GetJobListByCriteriaParams {
  servicename: string;
  startdate: string;
  status: string;
}

/**
 * @tags Batch Job Execution Controller
 * @summary getJobListByCriteria
 */
export function getJobListByCriteriaCollection(
  params: GetJobListByCriteriaParams
) {
  return request.get<AbstractResponse<object, BatchJobExecution>>(
    `${URL}/api/job` +
      prepareQueryParams({
        servicename: params.servicename,
        startdate: params.startdate,
        status: params.status,
      } as any)
  );
}
